export default __webpack_public_path__ + "static/media/app.c53b287a.mp4";